import PropTypes from 'prop-types';
import React from 'react';

import { getImageUrl } from '../../../../../helpers';
import BackgroundImage from '../../BackgroundImage';
import styles from './circle.scss';

const propTypes = {
  image_id: PropTypes.string,
  // points: PropTypes.number,
  placeholder: PropTypes.bool,
  count: PropTypes.number,
  size: PropTypes.number,
};

const Circle = ({
  image_id,
  // points,
  placeholder,
  count,
  size = 72,
}) => (
  <div
    className={styles.container}
    style={{ width: `${size}px`, height: `${size}px` }}
  >
    <div
      className={styles.circle}
    >
      { image_id
        && (
        <BackgroundImage
          className={styles.icon}
          src={getImageUrl(image_id)}
          // Calculation to find the largest square we can draw inside a circle
          // of the size given (default = 72). Make it a little bit smaller (82%).
          style={{
            backgroundSize: `${0.82 * Math.sqrt((size ** 2) / 2)}px ${0.82 * Math.sqrt((size ** 2) / 2)}px`,
            ...(placeholder && { opacity: 0.5, filter: 'grayscale(100%)' }),
          }}
        />
        )}
      { /* !placeholder && points > 0
        && (
        <div className={styles.pill}>
          +
          {points}
        </div>
      ) */ }
      { count > 1
        && (
        <div className={styles.count}>
          x
          {count}
        </div>
        )}
    </div>
  </div>
);

Circle.propTypes = propTypes;
export default Circle;
